import {
  Box,
  Button,
  Checkbox,
  Dialog,
  Grid,
  Hidden,
  IconButton,
  LinearProgress,
  Typography,
} from '@mui/material';
import React, { ChangeEvent, useEffect, useState } from 'react';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Location } from 'history';
import {
  bulkUpdateDistributorRM,
  editDistributor,
  getDistributorAndSRMByRmid,
  getRMsList,
  updateDistributorRM,
} from '../../redux-store/actions/userManagement';
import { useDispatch, useSelector } from 'react-redux';
import {
  RmWithDistributors,
  DistributorWithSubdistributor,
  DistributorListType,
  SubDistributorListType,
  newRmType,
  RmsType,
  distributorWisecommitmentType,
} from '../../redux-store/types/api-types';
import { DataTable } from '../DataTable';
import { Formik } from 'formik';
import MFSelectField from '../../lib/formik/SelectField';
import { AdminType, USER_ROLES } from '../../utils/constant';
import { useSnackbar } from 'notistack';
import { Notes } from '../investors/components';
import { ConfirmationDialog, LoadingDialog } from '../commonComponents';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { RootStateType } from '../../redux-store/reducers';
import { checkApplicableForYes } from '../../utils/utilityFunctions';

const checkBoxHeader = [
  {
    header: 'checkbox_ui',
    label: 'checkbox_ui',
  },
];

const headersIndividual = (val: boolean) => {
  return [
    {
      header: `${val ? 'RIA' : 'Distributor'} Name`,
      label: 'name',
    },
    {
      header: 'Email Id',
      label: 'email',
      valueGetter: (row: DistributorListType) => row.user?.email || 'N/A',
    },
    {
      header: 'Mobile Number',
      label: 'contact',
      valueGetter: (row: DistributorListType) => row.user?.phone || 'N/A',
    },
    // {
    //   header: 'PAN',
    //   label: 'panNumber',
    //   valueGetter: (row: DistributorListType) => row.panNumber || 'N/A',
    // },
    {
      header: 'ARN Code',
      valueGetter: (row: DistributorListType) => row.arnCode || 'N/A',
    },
  ];
};

const headersDistributorRm = (val: boolean) => {
  return [
    {
      header: `${val ? "RIA's" : "Distributor's"} RM name`,
      valueGetter: (row: SubDistributorListType) => row.user?.firstName || 'N/A',
    },
    {
      header: 'Email Id',
      valueGetter: (row: SubDistributorListType) => row.user?.email || 'N/A',
    },
    {
      header: 'Mobile Number',
      label: 'contact',
      valueGetter: (row: DistributorListType) => row.user?.phone || 'N/A',
    },

    // {
    //   header: 'PAN',
    //   valueGetter: (row: SubDistributorListType) => row.panNumber || 'N/A',
    // },
    {
      header: `${val ? "RIA's" : "Distributor's"} RM code`,
      valueGetter: (row: SubDistributorListType) => row.distributors_RM_Code || 'N/A',
    },
  ];
};

function MappedSrmsForRm({ location }: { location: Location<{ rmId: number }> }): JSX.Element {
  const { rmId: idForRm } = location.state || { rmId: '' };
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [checkAdminValidation, setAdminValidation] = useState<boolean>(false);
  const [distributorsByRmid, setDistributorsByRmid] = useState<DistributorWithSubdistributor[]>();
  const [selectedRowData, setSelectedRowData] = useState<DistributorListType[]>([]);
  const [open, setOpen] = useState<{
    distributorORSrmsRowData: DistributorListType[] | SubDistributorListType[];
  } | null>(null);
  const [selectedRM, setSelectRm] = useState<RmsType[]>([]);
  const [loadingPopup, setloadingPopup] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState<
    DistributorListType[] | SubDistributorListType[] | null
  >(null);
  const handleClose = () => {
    setOpen(null);
  };
  const handleLoadingPopupClose = () => {
    setloadingPopup(false);
  };
  const { location: branchLocation, admin_type } = useSelector(
    (store: RootStateType) => store.auth
  );
  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        if (idForRm) {
          const getDetails = (await dispatch(
            getDistributorAndSRMByRmid(idForRm)
          )) as unknown as RmWithDistributors;

          const distributorDataWithCheck = getDetails.distributors.map(
            (distriButorData: DistributorWithSubdistributor) => {
              if (distriButorData.type === 'individual') {
                return {
                  ...distriButorData,
                  isChecked: false,
                };
              } else if (distriButorData.type === 'company') {
                return {
                  ...distriButorData,
                  isChecked: false,
                  subdistributors: distriButorData.subdistributors.map(
                    (subdistributorData: SubDistributorListType) => {
                      return {
                        ...subdistributorData,
                        isChecked: false,
                      };
                    }
                  ),
                };
              }
            }
          );

          setDistributorsByRmid(distributorDataWithCheck as DistributorWithSubdistributor[]);

          setAdminValidation(
            (getDetails.distributors?.some(
              (distributor) => distributor.location === branchLocation
            ) &&
              getDetails.location === branchLocation) ||
              AdminType[admin_type] === AdminType.global
          );
        }

        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isComponentAlive = false;
    };
  }, []);

  const CheckAllDistributorDataIsChecked = (
    selectedRowDara: DistributorWithSubdistributor[]
  ): boolean => {
    return selectedRowDara?.every((data: DistributorWithSubdistributor) => {
      if (data.type === 'individual') {
        return data.isChecked;
      } else {
        return data.subdistributors.every((allSubData) => allSubData.isChecked);
      }
    });
  };

  const CheckSomeDistributorDataIsChecked = (
    selectedRowDara: DistributorWithSubdistributor[]
  ): boolean => {
    return selectedRowDara?.some((data: DistributorWithSubdistributor) => {
      if (data.type === 'individual') {
        return data.isChecked;
      } else {
        return data.subdistributors.some((allSubData) => allSubData.isChecked);
      }
    });
  };

  const checkUpdateRmValidation = (
    adminValidation: boolean,
    selectedRowData: DistributorWithSubdistributor[]
  ): boolean => {
    return (
      adminValidation &&
      selectedRowData.length > 0 &&
      CheckSomeDistributorDataIsChecked(selectedRowData)
    );
  };

  const filterSelectedRowData = (rowData: DistributorListType[]): DistributorListType[] => {
    return rowData.filter((data: DistributorListType) => data.isChecked);
  };

  const addSelectedRowData = (selectedData: DistributorWithSubdistributor[]) => {
    const updatedDistributors = distributorsByRmid?.map(
      (distributor: DistributorWithSubdistributor) => {
        const updatedData = selectedData.find((rowData: DistributorWithSubdistributor) => {
          return rowData.type === 'individual' && rowData.userId === distributor.userId;
        });

        if (updatedData) {
          return { ...distributor, isChecked: updatedData.isChecked };
        } else {
          distributor.subdistributors.forEach((subDistributor: SubDistributorListType) => {
            const selectedSubDistributorData = selectedData.find(
              (rowData: DistributorWithSubdistributor) => {
                return rowData.userId === subDistributor.userId;
              }
            );

            if (selectedSubDistributorData) {
              subDistributor.isChecked = selectedSubDistributorData.isChecked;
            }
          });
        }

        return distributor;
      }
    );

    const selectAllVal = CheckAllDistributorDataIsChecked(updatedDistributors || []);
    setSelectAll(selectAllVal || false);
    const selectedRows = updatedDistributors
      ?.map((distributor: DistributorWithSubdistributor) => {
        if (distributor.type === 'company') {
          return distributor.subdistributors;
        } else {
          return distributor;
        }
      })
      .flat();
    setSelectedRowData((selectedRows || []) as DistributorListType[]);
    setDistributorsByRmid(updatedDistributors);
  };

  const initialValues: { rmId?: number } = {
    rmId: open?.distributorORSrmsRowData[0]?.rmId,
  };

  const onSubmit = (values: { rmId?: number }) => {
    setOpenConfirmationDialog(
      filterSelectedRowData(selectedRowData).map((rowData) => {
        const { isChecked, ...rest } = rowData;
        return {
          ...rest,
          rmId: values.rmId,
        };
      }) as DistributorListType[] | SubDistributorListType[]
    );
  };

  const handleCheckBoxSelectAll = (val: boolean) => {
    const updatedData =
      distributorsByRmid?.flatMap((distributor: any) => {
        if (distributor.type === 'company') {
          return {
            ...distributor,
            subdistributors: distributor.subdistributors.map(
              (subdistributor: SubDistributorListType) => ({
                ...subdistributor,
                isChecked: val,
              })
            ),
          };
        } else if (distributor.type === 'individual') {
          return {
            ...distributor,
            isChecked: val,
          };
        }
      }) || [];
    setSelectAll(val);

    const selectedData = updatedData
      .map((distributor: DistributorWithSubdistributor) => {
        if (distributor.type === 'company') {
          return distributor.subdistributors;
        } else {
          return distributor;
        }
      })
      .flat();

    setSelectedRowData(selectedData as DistributorListType[]);
    setDistributorsByRmid(updatedData);
  };
  const addTableData = (distributors: DistributorWithSubdistributor) => {
    return distributors.type === 'company' ? distributors.subdistributors : [distributors];
  };
  return (
    <Box sx={{ bgcolor: 'common.white', px: 4 }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          pt: { xs: 2, sm: 7 },
          pb: 2,
          flexDirection: { xs: 'column', sm: 'row' },
        }}>
        <IconButton
          sx={{
            fontSize: 20,
            ':hover': {
              textDecoration: 'underline',
              backgroundColor: '#fff',
            },
          }}
          onClick={() => history.push('relationship-managers')}>
          {/* // <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} /> */}
          Relationship Managers
        </IconButton>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            width: '100%',
          }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <NavigateNextIcon fontSize="medium" />
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              {"List of Mapped SRM's"}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: ['100%', 'auto'],
            }}>
            <Typography
              variant="h5"
              sx={{
                color: checkUpdateRmValidation(checkAdminValidation, distributorsByRmid || [])
                  ? '#61D1D6'
                  : '#DDEAF3',
                textDecoration: 'none',
                fontWeight: 500,
                fontSize: '20px',
                cursor: checkUpdateRmValidation(checkAdminValidation, distributorsByRmid || [])
                  ? 'pointer'
                  : 'not-allowed',
                pointerEvents: checkUpdateRmValidation(
                  checkAdminValidation,
                  distributorsByRmid || []
                )
                  ? 'all'
                  : 'none',
              }}
              onClick={async () => {
                try {
                  setloadingPopup(true);
                  const res = (await dispatch(
                    getRMsList({ isActive: true })
                  )) as unknown as newRmType;
                  const { rms } = res || {};
                  const filteredRms = rms.filter((rm) =>
                    distributorsByRmid?.map((rmsData) => rmsData.location).includes(rm.location)
                  );
                  setSelectRm(filteredRms);
                  setOpen({
                    distributorORSrmsRowData: selectedRowData,
                  });
                  handleLoadingPopupClose();
                } catch (e) {
                  handleLoadingPopupClose();
                  console.error((e as Error).message);
                }
              }}>
              {'Update RM'}
            </Typography>

            <Button
              disabled={
                !(distributorsByRmid || []).length ||
                !(
                  distributorsByRmid?.every((data) => data.location === branchLocation) ||
                  AdminType[admin_type] === AdminType.global
                )
              }
              sx={{
                color: 'primary.main',
                fontWeight: 500,
                fontSize: 14,
                ml: { xs: 1, sm: 2.5 },
                p: 1,
              }}
              onClick={() => {
                handleCheckBoxSelectAll(!selectAll);
              }}
              variant="outlined"
              startIcon={<Checkbox checked={selectAll} sx={{ padding: 0, margin: 0 }} />}>
              Select All
            </Button>
          </Box>
        </Box>
      </Box>
      {/* <Box sx={{ pb: { xs: 2, sm: 4 } }}>
        <Notes displayContent={"If you want to update RM then SRM's should be active"} />
      </Box> */}
      {loading ? (
        <LinearProgress />
      ) : distributorsByRmid && distributorsByRmid.length > 0 ? (
        distributorsByRmid.map((distributorsByRm, index) => {
          return (
            <React.Fragment key={index}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    fontSize: 18,
                    fontWeight: 600,
                    color: 'primary.main',
                    pl: { xs: 2, sm: 2 },
                    textTransform: 'capitalize',
                    pt: 2,
                    pb: 0.5,
                  }}>
                  {distributorsByRm.name} {'(' + distributorsByRm.type + ')'}
                </Typography>
                {addTableData(distributorsByRm).length > 1 && (
                  <Hidden smUp={true}>
                    <Checkbox
                      sx={{
                        pt: 2,
                        pb: 0.5,
                      }}
                      checked={distributorsByRm?.subdistributors.every(
                        (allData) => allData.isChecked
                      )}
                      onChange={(e: ChangeEvent<HTMLInputElement>) => {
                        const updateAllData = addTableData(distributorsByRm).map((row: any) => {
                          return {
                            ...row,
                            isChecked: e.target.checked,
                          };
                        });

                        addSelectedRowData(updateAllData);
                      }}
                    />
                  </Hidden>
                )}
              </Box>

              <Grid item xs={12} sm={12} lg={12} sx={{ pb: 2 }}>
                <DataTable
                  widthProp={'10rem'}
                  addSelectedRowData={addSelectedRowData}
                  branchLocations={branchLocation}
                  tableData={addTableData(distributorsByRm)}
                  tableHeader={
                    distributorsByRm.type === 'company'
                      ? checkAdminValidation
                        ? [
                            ...checkBoxHeader,
                            ...headersDistributorRm(checkApplicableForYes(distributorsByRm?.isRia)),
                          ]
                        : [...headersDistributorRm(checkApplicableForYes(distributorsByRm?.isRia))]
                      : checkAdminValidation
                      ? [
                          ...checkBoxHeader,
                          ...headersIndividual(checkApplicableForYes(distributorsByRm?.isRia)),
                        ]
                      : [...headersIndividual(checkApplicableForYes(distributorsByRm?.isRia))]
                  }
                  isLoading={loading}
                  renderAdditionalRow={true}
                  tableBodyCustomStyles={{
                    '.MuiTableCell-root': {
                      borderBottom: 'none',
                    },
                  }}
                  tableHeaderCustomStyles={{
                    '&:last-child th': { border: 0 },
                    '.MuiTableCell-head': {
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'primary.main',
                    },
                  }}
                  boxStyles={{
                    maxHeight: 'calc(100vh - 240px)',
                    minHeight: '150px',
                  }}
                />
              </Grid>
            </React.Fragment>
          );
        })
      ) : (
        <Typography
          sx={{
            textAlign: 'center',
            height: 100,
          }}>
          No data found
        </Typography>
      )}

      <Dialog
        onClose={handleClose}
        open={open !== null}
        sx={{
          '.MuiPaper-root ': {
            py: 4,
            px: 2,
            width: { xs: '90%', sm: '70%' },
          },
        }}>
        <Box
          sx={{
            width: { xs: '100%', sm: '80%' },
            mx: 'auto',
            '.MuiTypography-root': {
              fontSize: 18,
              fontWeight: 500,
              textAlign: 'center',
            },
          }}>
          <Typography sx={{ color: 'primary.main' }}>Update RM</Typography>
          <Formik initialValues={initialValues} onSubmit={onSubmit}>
            {({ handleSubmit, values }) => (
              <Box component="form" noValidate onSubmit={handleSubmit}>
                <SearchableSelect
                  name="rmId"
                  label="RM Name"
                  items={selectedRM
                    .sort((rm1, rm2) =>
                      (rm1['name'] || '').toString().localeCompare((rm2['name'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.name,
                      value: item.id,
                    }))}
                  searchFieldPlaceholder={'Search RM'}
                />

                <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                    variant="outlined"
                    sx={{
                      fontSize: 15,
                      color: 'primary.main',
                      minWidth: 180,
                      letterSpacing: 2,
                      fontWeight: 500,
                    }}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      fontSize: 15,
                      minWidth: 180,
                      letterSpacing: 2,
                      fontWeight: 400,
                    }}
                    type="submit">
                    Update
                  </Button>
                </Grid>
              </Box>
            )}
          </Formik>
        </Box>
      </Dialog>
      <ConfirmationDialog
        message={`Are you sure you want to update the RM ?`}
        open={openConfirmationDialog !== null}
        setOpen={() => setOpenConfirmationDialog(null)}
        onSave={async () => {
          try {
            handleClose();
            setOpenConfirmationDialog(null);
            setloadingPopup(true);
            await dispatch(
              bulkUpdateDistributorRM(openConfirmationDialog as DistributorListType[])
            );

            const getDetails = (await dispatch(
              getDistributorAndSRMByRmid(idForRm)
            )) as unknown as RmWithDistributors;
            setDistributorsByRmid(getDetails.distributors as DistributorWithSubdistributor[]);
            handleLoadingPopupClose();
            enqueueSnackbar('RM Updated Successfully', {
              variant: 'success',
              autoHideDuration: 3000,
            });

            setSelectedRowData([]);
            setSelectAll(false);
          } catch (e) {
            handleLoadingPopupClose();
            console.error((e as Error).message);
          }
        }}
        onCancel={() => setOpenConfirmationDialog(null)}
      />
      <LoadingDialog loadingPopup={loadingPopup} onLoadingPopupClose={handleLoadingPopupClose} />
    </Box>
  );
}
export default MappedSrmsForRm;
